import { createUseStyles } from 'react-jss'


export default createUseStyles({
  container: {},
})
